import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalEditorCropIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-editor-crop"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M1.667 5h10.666c.934 0 1.4 0 1.757.182.314.16.569.414.728.728.182.357.182.823.182 1.757v10.666M18.333 15H7.667c-.934 0-1.4 0-1.757-.182a1.67 1.67 0 0 1-.728-.728C5 13.733 5 13.267 5 12.333V1.667"
        />
    </svg>
);
const Memo = memo(ImageModalEditorCropIcon);
export default Memo;
